<template>
    <div class="ma-8">
        <h1>404</h1>
        <h3 v-if="displayNotFound">Požadovaný displej nebyl nalezen.</h3>
        <h3 v-else>Požadovaná stránka neexistuje.</h3>
        <br/>
        <div v-if="displayNotFound">
            <p class="mb-0">Zkontrolujte prosím platnost zadaného ID displeje.</p>
            <p>Následně zadejte adresu ve tvaru <code>{{baseUrl}}/?id=26</code></p>
        </div>
        <div v-else>
            <p class="mb-0">Zkontrolujte prosím zadanou adresu.</p>
            <p>Pro zobrazení obsahu displeje musí být adresa ve tvaru <code>{{baseUrl}}/?id=26</code></p>
        </div>
        <br/>
        <a href="/">Zpět na přehled displejů</a>
    </div>
</template>

<script>
export default {
    name: "NotFound",

    props: {
        displayNotFound: Boolean
    },

    data() {
        return {
            baseUrl: window.location.protocol + '//' + window.location.host
        };
    },
}
</script>

<style scoped>
  a {
    color: #7BB916 !important;
    text-decoration: none;
  }
</style>
